<script setup>
import { computed } from 'vue';
import { useSidebar } from 'next/polaris/ui/sidebar';
import {
  isConversationPanelMounted,
  useConversationPanel,
} from 'dashboard/composables/useConversationPanel';
import { useUISettings } from 'dashboard/composables/useUISettings';
import Topbar from 'next/polaris/shell/Topbar.vue';

// The dashboard's top bar, inside the sidebar provider so it reaches the same toggle the icon rail uses. The menu
// button folds tier 1 on desktop; on a phone it opens the navigation sheet, which the dashboard owns (it also
// closes the sheet), and puts the conversation panel away first so two overlays are never open together.
defineProps({
  area: { type: String, default: '' },
  trail: { type: Array, default: () => [] },
  sectionOpen: { type: Boolean, default: false },
  hasSection: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleSection', 'openMobileSidebar']);

const { isMobile, state, toggleSidebar } = useSidebar();
const conversationPanel = useConversationPanel();
const { updateUISettings } = useUISettings();

const onToggleMain = () => {
  if (!isMobile.value) {
    toggleSidebar();
    return;
  }
  // Only what is on screen, and only its own setting: the conversation panel when a conversation is open, the
  // Ask overlay when it is showing. Saved settings alone are not a panel, so nothing else is written.
  if (isConversationPanelMounted.value) {
    if (conversationPanel.isOpen.value) conversationPanel.close();
  } else if (conversationPanel.isAskOpen.value) {
    updateUISettings({ is_copilot_panel_open: false });
  }
  emit('openMobileSidebar');
};
const mainCollapsed = computed(() => state.value === 'collapsed');
</script>

<template>
  <Topbar
    :area="area"
    :trail="trail"
    :section-open="sectionOpen"
    :has-section="hasSection"
    :is-mobile="isMobile"
    :main-collapsed="mainCollapsed"
    @toggle-main="onToggleMain"
    @toggle-section="emit('toggleSection')"
  >
    <template #actions>
      <slot name="actions" />
    </template>
  </Topbar>
</template>
